import {combineReducers} from "redux";
import {ThemeReducer} from "./theme";
import {ThemeState} from "@/configs/ThemeConfig";

export const reducers = combineReducers({
    theme: ThemeReducer,
});
export interface RootState {
    theme: ThemeState;
}
